import { useRef } from 'react';
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import { useGSAP } from '@gsap/react'
import Impact from './Impact';
gsap.registerPlugin(ScrollTrigger)

function ImpactScroller() {
    const impactSection = useRef();
    // const [domReady, setDomReady] = useState(false);

//     // dom loaded
//     useEffect(() => {
//         const checkDOMReady = () => {
//             const miawwElement = document.querySelector('.miaww');
//             const miawwRect = miawwElement.getBoundingClientRect();
//             if (miawwRect.width > 0 && miawwRect.height > 0) {
//                 setDomReady(true);
//                 return;
//             };
//         };

//         setTimeout(checkDOMReady, 50);
//     }, []);

//     useGSAP(() => {
//   const ctx = gsap.context(() => {
//     if (!domReady) return;
    
//     let match = gsap.matchMedia();
    
//     // Para desktop
//     match.add("(min-width: 768px)", () => {
//       gsap.set(".impactodial", {
//         rotation: 0
//       });
      
//       gsap.delayedCall(0.1, () => {
//       gsap.to(".activity-div", {
//         scrollTrigger: {
//           trigger: ".miaww",
//           start: "bottom bottom",
//           end: "+=300",
//           scrub: true,
//           pin: ".miaww",
//           markers: true
//         },
//         xPercent: -500
        
        
//       });
//     });
//     });
    
//     // Para mobile
//     match.add("(max-width: 767px)", () => {
//       gsap.set(".animated-box", {
//         rotation: 0
//       });
      
//       gsap.to(".activity-div", {
//         scrollTrigger: {
//           trigger: ".animated-box",
//           start: "center center",
//           end: "+=200", // Menor distancia en mobile
//           scrub: true,
//           pin: '.miaww',
//           markers: false,
//           invalidateOnRefresh: true
//         },
//         rotation: 500, // Menor rotación en mobile si quieres
//         immediateRender: false
//       });
//     });
    
//     return () => {
//       match.kill();
//     };
//   });
  
//   return () => ctx.revert();
// }, {scope: impactSection, dependencies: [domReady]});

    return(
      <div className='bg-gradient-to-b from-bluekali-han-purple to-bluekali-navy-blue'>
        <div ref={impactSection} className='w-full impactodial overflow-hidden'>
            <Impact/>
        </div>
      </div>
    )
}

export default ImpactScroller;